import mixpanel from "mixpanel-browser";

export const dashboardEventsTracker = (
  title,
  email,
  data = {},
  loggedInUser,
  ltUser
) => {
  if (ltUser) {
    mixpanel.track(
      title,
      {
        ...data,
        Medium: "Broker",
        $distinct_id: ltUser?.email,
        source: "Luckytruck site",
        userEmail: ltUser?.email,
        "Opted out of email": true,
      },
      (res) => {}
    );
  } else {
    mixpanel.track(
      title,
      {
        ...data,
        Medium: "User",
        source: "Luckytruck site",
        userEmail: loggedInUser ? loggedInUser.email : email,
        LTuserEmail: ltUser ? ltUser.email : "",
        "Opted out of email": true,
      },
      (res) => {}
    );
  }
};

export const indicationCreationEventTracker = (data, loggedInUser, ltUser) => {
  if (ltUser) {
    mixpanel.track(
      "IndicationCreated",
      {
        ...data,
        source: "Luckytruck site",
        $distinct_id: ltUser?.email,
        userEmail: ltUser?.email,
        "Opted out of email": true,
      },
      (res) => {}
    );
  }
  mixpanel.track("IndicationCreated", {
    ...data,
    source: "Luckytruck site",
    userEmail: loggedInUser ? loggedInUser.email : email,
    LTuserEmail: ltUser ? ltUser.email : "",
    "Opted out of email": true,
  });
};

export const landingPagesMixPanelEventTracker = (title) => {
  mixpanel.track(title, {
    source: "Lucktruck site",
    "Opted out of email": true,
  });
};
